/* ============================================================
   RAKK — rakk-product.js  v8
   ============================================================ */
(function () {
  'use strict';

  /* ── Taux financement (pillules hors modal — inchangé) ────── */
  const INSTALLMENT_CONFIG = {
    '3x':  { months: 3,  provider: 'Alma'    },
    '4x':  { months: 4,  provider: 'Alma'    },
    '10x': { months: 10, provider: 'Younited' },
    '24x': { months: 30, provider: 'Sofinco' },
    '60x': { months: 60, provider: 'Sofinco' },
  };

  /* Dernier slider touché par l'utilisateur */
  let lastActiveProvider = null;

  function computeMonthly(price, key) {
    const cfg = INSTALLMENT_CONFIG[key];
    if (!cfg) return '—';
    return formatAmount(price / cfg.months);
  }

  function formatAmount(n) { return n.toFixed(2).replace('.', ','); }

  function getCurrentPrice() {
    const el = document.getElementById('rakk-pricing-block');
    return el ? parseFloat(el.dataset.price || '0') : 0;
  }

  function getActivePillKey() {
    const active = document.querySelector('.rakk-inst-pill.active');
    return active ? active.dataset.key : '60x';
  }

  function activatePill(key) {
    document.querySelectorAll('.rakk-inst-pill').forEach(p =>
      p.classList.toggle('active', p.dataset.key === key));

    const price = getCurrentPrice();
    const cfg   = INSTALLMENT_CONFIG[key];
    if (!cfg) return;
    const monthly = computeMonthly(price, key);

    const elMonthly = document.getElementById('rakk-fin-monthly');
    const elMonths  = document.getElementById('rakk-fin-months');
    if (elMonthly) elMonthly.textContent = monthly + ' €/mois';
    if (elMonths)  elMonths.textContent  = cfg.months;
  }

  /* ── Coloration de la piste du slider ─────────────────────── */
  function updateSliderTrack(slider) {
    const min = parseFloat(slider.min);
    const max = parseFloat(slider.max);
    const val = parseFloat(slider.value);
    const pct = max > min ? ((val - min) / (max - min)) * 100 : 0;
    slider.style.background =
      `linear-gradient(to right, #FAB10D 0%, #FAB10D ${pct}%, #e0e0e0 ${pct}%, #e0e0e0 100%)`;
  }

  /* ── Badge "Sans frais" Alma : visible seulement si index ≤ 2 (2×,3×,4×) ── */
  function updateAlmaFreeBadge(slider) {
    const row = slider.closest('.rakk-provider-row');
    if (!row || row.dataset.provider !== 'alma') return;
    const badge = row.querySelector('.rakk-badge-free');
    if (!badge) return;
    const idx = parseInt(slider.value, 10);
    // index 0=2x, 1=3x, 2=4x → sans frais ; index 3=10x → avec frais
    badge.style.display = idx <= 2 ? '' : 'none';
  }

  function updateAlmaFreeBadgeAll() {
    document.querySelectorAll('.rakk-slider[data-provider="alma"]').forEach(updateAlmaFreeBadge);
  }

  /* ── Highlight du provider actif (bordure colorée) ─────────── */
  function highlightActiveProvider(provider) {
    document.querySelectorAll('.rakk-provider-row[data-provider]').forEach(row => {
      const isActive = row.dataset.provider === provider
        && !row.classList.contains('rakk-provider-disabled');
      row.classList.toggle('rakk-provider-active', isActive);
    });
  }

  /* ── Désactiver prestataires hors plage + label Min/Max ────── */
  function checkProvidersAvailability() {
    const price = getCurrentPrice();
    document.querySelectorAll('.rakk-provider-row[data-provider]').forEach(row => {
      const min = parseFloat(row.dataset.min || '0');
      const max = parseFloat(row.dataset.max || '999999');
      const disabled = price < min || price > max;
      row.classList.toggle('rakk-provider-disabled', disabled);

      const rangeEl = row.querySelector('.rakk-provider-range');
      if (rangeEl) {
        const minFmt = min.toLocaleString('fr-FR');
        const maxFmt = max.toLocaleString('fr-FR');
        rangeEl.textContent = `Min. ${minFmt} € — Max. ${maxFmt} €`;
        rangeEl.classList.toggle('rakk-provider-range--error', disabled);
      }
    });

    // Si le provider actif est maintenant désactivé → passer au premier dispo
    if (lastActiveProvider) {
      const activeRow = document.querySelector(
        `.rakk-provider-row[data-provider="${lastActiveProvider}"]`
      );
      if (activeRow && activeRow.classList.contains('rakk-provider-disabled')) {
        const firstAvail = document.querySelector(
          '.rakk-provider-row[data-provider]:not(.rakk-provider-disabled)'
        );
        lastActiveProvider = firstAvail ? firstAvail.dataset.provider : null;
      }
    } else {
      // Init : sélectionner le premier provider disponible
      const firstAvail = document.querySelector(
        '.rakk-provider-row[data-provider]:not(.rakk-provider-disabled)'
      );
      if (firstAvail) lastActiveProvider = firstAvail.dataset.provider;
    }

    highlightActiveProvider(lastActiveProvider);
  }

  /* ── Lire le label d'un slider selon sa position ─────────── */
  function getSliderLabel(slider) {
    const stepsAttr = slider.dataset.steps;
    if (stepsAttr === 'sofinco-continuous') {
      return `${slider.value}×`;
    }
    const labels = JSON.parse(slider.dataset.labels);
    const idx = parseInt(slider.value, 10);
    return labels[idx] || '—';
  }

  /* ── Lire le nombre de mois d'un slider ──────────────────── */
  function getSliderMonths(slider) {
    const stepsAttr = slider.dataset.steps;
    if (stepsAttr === 'sofinco-continuous') {
      return parseInt(slider.value, 10);
    }
    const steps = JSON.parse(stepsAttr);
    const idx = parseInt(slider.value, 10);
    return parseInt(steps[idx], 10);
  }

  /* ── Est-ce que c'est "sans frais" ? (Alma index 0-2) ─────── */
  function isFreePlan(slider) {
    const row = slider.closest('.rakk-provider-row');
    if (!row || row.dataset.provider !== 'alma') return false;
    return parseInt(slider.value, 10) <= 2;
  }

  /* ── Résumé modal : 1 seule ligne = dernier slider modifié ── */
  function updateModalSummaryFromSliders() {
    const el = document.getElementById('rakk-modal-summary-text');
    if (!el) return;

    if (!lastActiveProvider) {
      el.innerHTML = '<span style="color:#999">Aucun prestataire disponible pour ce montant.</span>';
      return;
    }

    const price  = getCurrentPrice();
    const slider = document.querySelector(`.rakk-slider[data-provider="${lastActiveProvider}"]`);
    if (!slider) {
      el.innerHTML = '<span style="color:#999">Sélectionnez une durée.</span>';
      return;
    }

    const row = slider.closest('.rakk-provider-row');
    if (!row || row.classList.contains('rakk-provider-disabled')) {
      el.innerHTML = '<span style="color:#999">Prestataire non disponible pour ce montant.</span>';
      return;
    }

    const providerName = { alma: 'Alma', younited: 'Younited', sofinco: 'Sofinco' }[lastActiveProvider] || lastActiveProvider;
    const label        = getSliderLabel(slider);
    const months       = getSliderMonths(slider);
    const monthly      = months > 0 ? formatAmount(price / months) : '—';
    const freeTag      = isFreePlan(slider) ? ' sans frais' : ' mensualités';

    el.innerHTML = `
      <span class="summary-line">
        <strong>${providerName}</strong> — ${label}${freeTag} :
        <span class="summary-monthly">${monthly} €/mois</span>
      </span>
    `;
  }

  /* ── Modal financement ──────────────────────────────────────
     Téléportée dans <body> pour échapper à tout z-index parent
  ─────────────────────────────────────────────────────────── */
  let lastFocused = null;

  function openModal() {
    const modal = document.getElementById('rakk-financing-modal');
    if (!modal) return;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    const focusable = getFocusableElements(modal);
    if (focusable.length) focusable[0].focus();
    checkProvidersAvailability();
    updateAlmaFreeBadgeAll();
    updateModalSummaryFromSliders();
    document.querySelectorAll('.rakk-slider').forEach(updateSliderTrack);
  }

  function closeModal() {
    const modal = document.getElementById('rakk-financing-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(
      'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
    )).filter(el => !el.disabled && el.offsetParent !== null);
  }

  function trapFocus(e) {
    const modal = document.getElementById('rakk-financing-modal');
    if (!modal || !modal.classList.contains('is-open')) return;
    const focusable = getFocusableElements(modal);
    if (!focusable.length) return;
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === focusable[0]) {
          e.preventDefault();
          focusable[focusable.length - 1].focus();
        }
      } else {
        if (document.activeElement === focusable[focusable.length - 1]) {
          e.preventDefault();
          focusable[0].focus();
        }
      }
    }
    if (e.key === 'Escape') closeModal();
  }

  /* ── Mise à jour prix au changement de variant ────────────── */
  function handleVariantChange(e) {
    const variant = e.detail?.variant;
    if (!variant) return;
    const block = document.getElementById('rakk-pricing-block');
    if (!block) return;
    block.dataset.price = variant.price / 100;
    updatePriceDisplay(variant);
    activatePill(getActivePillKey());
    checkProvidersAvailability();
    updateModalSummaryFromSliders();
  }

  function updatePriceDisplay(variant) {
    const elCurrent = document.querySelector('.rakk-price-current');
    if (!elCurrent || !variant) return;
    const price = variant.price / 100;
    elCurrent.textContent = price.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    const elOld  = document.querySelector('.rakk-price-old');
    const elSave = document.querySelector('.rakk-price-save');
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const old = variant.compare_at_price / 100;
      if (elOld)  { elOld.textContent  = old.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); elOld.style.display = ''; }
      if (elSave) { elSave.textContent = '−' + (old - price).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); elSave.style.display = ''; }
    } else {
      if (elOld)  elOld.style.display  = 'none';
      if (elSave) elSave.style.display = 'none';
    }
    const elStock = document.querySelector('.rr-stock');
    if (elStock) {
      elStock.className = 'rr-stock ' + (variant.available ? 'in-stock' : 'out-stock');
      elStock.textContent = variant.available
        ? (elStock.dataset.inText  || 'En stock')
        : (elStock.dataset.outText || 'Rupture de stock');
    }
  }

  /* ── Accordéon accessoires RAKK ──────────────────────────── */
  function initAccessoiresAccordion() {
    const acc = document.getElementById('rakk-accessories-accordion');
    if (!acc) return;
    const toggle  = acc.querySelector('.rakk-acc-toggle');
    const body    = acc.querySelector('.rakk-acc-body');
    const chevron = acc.querySelector('.rakk-acc-chevron');
    if (!toggle || !body) return;

    let open = acc.dataset.defaultOpen !== 'false';
    function setOpen(state) {
      open = state;
      body.style.maxHeight   = open ? body.scrollHeight + 'px' : '0';
      body.style.overflow    = open ? '' : 'hidden';
      chevron && chevron.classList.toggle('rotated', open);
      toggle.setAttribute('aria-expanded', String(open));
    }

    body.style.transition = 'none';
    setOpen(open);
    requestAnimationFrame(() => {
      body.style.transition = 'max-height .35s cubic-bezier(.4,0,.2,1)';
    });

    toggle.addEventListener('click', () => setOpen(!open));

    const ro = new ResizeObserver(() => { if (open) body.style.maxHeight = body.scrollHeight + 'px'; });
    ro.observe(body);
  }

  /* ── Init ───────────────────────────────────────────────── */
  function init() {
    const block = document.getElementById('rakk-pricing-block');
    if (block) {
      /* Téléporter la modal dans <body> */
      const modal = document.getElementById('rakk-financing-modal');
      if (modal && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      /* Boutons modal */
      document.getElementById('rakk-btn-open-financing-modal')
        ?.addEventListener('click', openModal);
      document.getElementById('rakk-modal-close')
        ?.addEventListener('click', closeModal);
      document.getElementById('rakk-modal-cta')
        ?.addEventListener('click', () => {
          window.location.href = '/pages/paiement-en-60x';
        });
      document.querySelector('#rakk-financing-modal .rakk-modal-backdrop')
        ?.addEventListener('click', closeModal);
      document.addEventListener('keydown', trapFocus);

      /* Pillules hors-modal (résumé en ligne) */
      document.querySelectorAll('.rakk-inst-pill').forEach(pill =>
        pill.addEventListener('click', () => activatePill(pill.dataset.key)));

      const defaultActive = document.querySelector('.rakk-inst-pill.active');
      if (defaultActive) activatePill(defaultActive.dataset.key);

      /* Sliders dans la modal */
      document.querySelectorAll('.rakk-slider').forEach(slider => {
        updateSliderTrack(slider);

        slider.addEventListener('input', () => {
          const row = slider.closest('.rakk-provider-row');
          if (row && !row.classList.contains('rakk-provider-disabled')) {
            lastActiveProvider = row.dataset.provider;
            highlightActiveProvider(lastActiveProvider);
          }
          updateSliderTrack(slider);
          updateAlmaFreeBadge(slider);
          updateModalSummaryFromSliders();
        });

        // Cliquer sur la row = activer ce provider
        const row = slider.closest('.rakk-provider-row');
        if (row) {
          row.addEventListener('click', () => {
            if (row.classList.contains('rakk-provider-disabled')) return;
            lastActiveProvider = row.dataset.provider;
            highlightActiveProvider(lastActiveProvider);
            updateModalSummaryFromSliders();
          });
        }
      });

      /* Disponibilité et état initial */
      checkProvidersAvailability();
      updateAlmaFreeBadgeAll();

      /* Changement de variant */
      document.addEventListener('variant:change', handleVariantChange);
      const variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          activatePill(getActivePillKey());
          checkProvidersAvailability();
          updateModalSummaryFromSliders();
        });
      }
    }

    /* Accordéon accessoires */
    initAccessoiresAccordion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();